/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
 
import { useOktaAuth } from '@okta/okta-react';
import { get } from 'jquery';
import React, { useState, useEffect } from 'react';
import { Button, Header } from 'semantic-ui-react';

import config from './config';
import {getAuthorizedFactoryFromAirtable} from './services/IO'

const { env, redirectUri, disableHttpsCheck } = config.oidc;

const Home = () => {
  const { authState, authService } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);
  const [formTypes, setFormTypes] = useState(null)

  if (env === 'DEV'){
    console.log('***** env ', env)
    console.log('***** redirectUri ', redirectUri)
    console.log('***** disableHttpsCheck ', disableHttpsCheck)
  }

  


  useEffect( () => {
    
    if (!authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      setUserInfo(null);
    } else {
      authService.getUser().then( (info) => {
        if (info){
          setUserInfo(info);

          (async () => {
            let factories = await getAuthorizedFactoryFromAirtable(info.email, authState.accessToken)
            
            if (factories && factories.formTypes && factories.formTypes.length && factories.formTypes.length > 0){
              setFormTypes(factories.formTypes)
            }
          })();

        }
        
      })
    }

    // return () => {
    //   console.log("This will be logged on unmount");
    // }

  }, [authState, authService]); // Update if authState changes

  const login = async () => {
    authService.login('/');
  };



  // const resourceServerExamples = [
  //   {
  //     label: 'Node/Express Resource Server Example',
  //     url: 'https://github.com/okta/samples-nodejs-express-4/tree/master/resource-server',
  //   },
  //   {
  //     label: 'Java/Spring MVC Resource Server Example',
  //     url: 'https://github.com/okta/samples-java-spring-mvc/tree/master/resource-server',
  //   },
  // ];

  if (authState.isPending) {
    return (
      <div>Loading...</div>
    );
  }

  return (
    <div>
      <div>
        <Header as="h1">Welcome to Cole Haan Costing</Header>

        { authState.isAuthenticated && !userInfo
        && <div>Loading user information...</div>}

        {authState.isAuthenticated && userInfo
        && (
        <div>
          <p>
            Welcome back,
            {userInfo.name}
            !
          </p>
          <p>
            You are successfully logged in. <br /> 
            
            Please visit the 
            <br />{  (formTypes && formTypes.find(value => value === 'Footwear') && <a href="/form">Footwear Costing Form Page</a>  )} 
            <br />{(formTypes && formTypes.find(value => value === 'Accessories') && <a href="/accessories">Accessories Costing Form Page</a>  )} 
            <br />to input your data.
          </p>
          <p>
            Visit the
            {' '}
            <a href="/profile">My Profile</a>
            {' '}
            page to view your logged in information.
          </p>
          {/* <h3>Next Steps</h3>
          <p>Some copy here</p>
          <p>Some copy here</p> */}
          {/* <ul>
            {resourceServerExamples.map((example) => <li key={example.url}><a href={example.url}>{example.label}</a></li>)}
          </ul> */}
          {/* <p>
            Once you have downloaded and started the example resource server, you can visit the
            <a href="/messages">My Messages</a>
            {' '}
            page to see the authentication process in action.
          </p> */}
        </div>
        )}

        {!authState.isAuthenticated
        && (
        <div>
          <p>Please log into the Cole Haan Costing Application</p>
 
          <p>
            USE GOOGLE LOG IN ONLY
          </p>
          <Button id="login-button" primary onClick={login}>Login</Button>
        </div>
        )}

      </div>
    </div>
  );
};
export default Home;
